import React from "react";
import FilterBar from "../common/FilterBar";

// User Master filters on the shared FilterBar. Profile and status are stored as
// { value, label } objects, as the user fetch and export already expect.

export const PROFILE_OPTIONS = [
  { value: "CUSTOMER", label: "LMBP" },
  { value: "OPERATION", label: "Operation" },
  { value: "FRANCHISE", label: "Franchise" },
  { value: "HUB", label: "Hub" },
];

export const STATUS_OPTIONS = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
  { value: "2", label: "New User" },
  { value: "3", label: "Blocked" },
  { value: "5", label: "Awaiting Customer Authorization" },
];

const asOption = {
  toValue: (stored) => stored?.value || "",
  fromOption: (option) => option || null,
};

const UserFilterBar = ({ filters, onChange }) => (
  <FilterBar
    values={filters}
    onChange={onChange}
    search={{ key: "search", placeholder: "Search name, email, mobile, user ID or LMBP / hub code" }}
    selects={[
      { key: "userProfile", allLabel: "All profiles", chipLabel: "Profile", options: PROFILE_OPTIONS, ...asOption },
      { key: "status", allLabel: "All statuses", chipLabel: "Status", options: STATUS_OPTIONS, ...asOption },
    ]}
    dateRange={{ fromKey: "fromDate", toKey: "toDate", label: "Created" }}
  />
);

export default UserFilterBar;
